/* eslint-disable indent */
import { EmailReminderTriggerType } from '@/api/entities/email-reminder';
import { getLanguage } from '@/utils/language.utils';
import { TFunction } from 'i18next';

const getDayAbbreviation = () => {
  const { languageCode } = getLanguage();
  switch (languageCode) {
    case 'fr':
      return 'J';
    case 'en':
      return 'Day';
    default:
      return 'Day';
  }
};

export const getTriggerOptions = () => {
  const options = [];
  const dayAbbreviation = getDayAbbreviation();

  for (let i = -10; i <= 10; i++) {
    options.push({
      label: i < 0 ? `${dayAbbreviation}${i}` : `${dayAbbreviation}+${i}`,
      value: `${i}`,
    });
  }
  return options;
};

export const getConditionOptions = (t: TFunction<undefined>) => {
  return [
    {
      label: t('common:inspectionNotStarted'),
      value: EmailReminderTriggerType.INSPECTION_NOT_STARTED,
    },
    {
      label: t('common:inspectionCompleted'),
      value: EmailReminderTriggerType.INSPECTION_COMPLETED,
    },
    {
      label: t('common:allTimes'),
      value: EmailReminderTriggerType.ALL_TIMES,
    },
  ];
};
